import axios from "axios";
import { apiUrl } from "./env";

const apiFashionInstance = axios.create({
  baseURL: apiUrl,
  timeout: 10000,
});

const apiFashionService = {
  getArticles(userToken, { resultsPerPage, actualPage, order, status, query }) {
    return apiFashionInstance({
      method: "GET",
      url: `/article?product=14&limit=${resultsPerPage}&page=${actualPage}${order}${status}${query}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  getArticleById(userToken, id) {
    return apiFashionInstance({
      method: "GET",
      url: `/article/detail?id=${id}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  createArticle(userToken, data) {
    return apiFashionInstance({
      method: "POST",
      url: "/article?product=14",
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },
  setArticle(userToken, data) {
    return apiFashionInstance({
      method: "PUT",
      url: "/article?product=14",
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },
  deleteArticle(userToken, ids) {
    return apiFashionInstance({
      method: "DELETE",
      url: "/article",
      headers: {
        Authorization: userToken,
      },
      data: { idList: ids },
    });
  },
  getRelatedArticle(userToken, articleId) {
    return apiFashionInstance({
      method: "GET",
      url: `/article/related?articleId=${articleId}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  setRelatedArticle(userToken, articleId, relatedId) {
    return apiFashionInstance({
      method: "POST",
      url: "/article/related",
      headers: {
        Authorization: userToken,
      },
      data: {
        articleId,
        relatedId,
      },
    });
  },
  deleteRelatedArticle(userToken, articleId, relatedId) {
    return apiFashionInstance({
      method: "DELETE",
      url: "/article/related",
      headers: {
        Authorization: userToken,
      },
      data: {
        articleId,
        relatedId,
      },
    });
  },
  relatedSearchArticle(userToken, query, articleId) {
    return apiFashionInstance({
      method: "GET",
      url: `/article/related/search?query=${query}&id=${articleId}`,
      headers: {
        Authorization: userToken,
      },
    });
  },

  // banners methods
  getBanners(userToken) {
    return apiFashionInstance({
      method: "GET",
      url: `/banner`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  getBannerById(userToken, id) {
    return apiFashionInstance({
      method: "GET",
      url: `/banner/${id}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  createBanner(userToken, data) {
    return apiFashionInstance({
      method: "POST",
      url: "/banner",
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },
  setBanner(userToken, bannerId, data) {
    return apiFashionInstance({
      method: "PUT",
      url: `/banner/${bannerId}`,
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },
  deleteBanner(userToken, ids) {
    return apiFashionInstance({
      method: "DELETE",
      url: "/banner",
      headers: {
        Authorization: userToken,
      },
      data: { idList: ids },
    });
  },
  getAppAreas(userToken) {
    return apiFashionInstance({
      method: "GET",
      url: "/banner/area",
      headers: {
        Authorization: userToken,
      },
    });
  },
  getAppAreaById(userToken, areaId) {
    return apiFashionInstance({
      method: "GET",
      url: `/banner/area/${areaId}`,
      headers: {
        Authorization: userToken,
      },
    });
  },

  // theme methods
  getThemes(userToken, page = 1, limit = 10) {
    return apiFashionInstance({
      method: "GET",
      url: `/theme/?product=14&page=${page}&limit=${limit}`,
      headers: {
        Authorization: userToken,
      },
    });
  },

  // author methods
  getAuthors(userToken, page = 1, limit = 10) {
    return apiFashionInstance({
      method: "GET",
      url: `/author/?page=${page}&limit=${limit}`,
      headers: {
        Authorization: userToken,
      },
    });
  },

  // tags
  getTags(userToken, tag = "") {
    return apiFashionInstance({
      method: "GET",
      url: `/tag?query=${tag}`,
      headers: {
        Authorization: userToken,
      },
    });
  },

  // faq methods
  getFaqById(userToken, productId) {
    return apiFashionInstance({
      method: "GET",
      url: `/faq?productId=${productId}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  getFaqItemById(userToken, itemId) {
    return apiFashionInstance({
      method: "GET",
      url: `/faq/detail/${itemId}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  createFaqItem(userToken, data) {
    return apiFashionInstance({
      method: "POST",
      url: "/faq/",
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },
  setFaqItem(userToken, data) {
    return apiFashionInstance({
      method: "PUT",
      url: "/faq/",
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },
  deleteFaqItem(userToken, ids) {
    return apiFashionInstance({
      method: "DELETE",
      url: "/faq/",
      headers: {
        Authorization: userToken,
      },
      data: { idList: ids },
    });
  },

  // terms methods
  getTermById(userToken, productId) {
    return apiFashionInstance({
      method: "GET",
      url: `/terms?productId=${productId}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  setTerm(userToken, data) {
    return apiFashionInstance({
      method: "PUT",
      url: "/terms/",
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },

  // professions
  // =================================================

  getProfessions(
    userToken,
    { resultsPerPage, actualPage, status = "", query = "", orderType, order }
  ) {
    const filterParam = status ? `&filter=${status}` : "";
    const queryParam = query ? `&query=${query}` : "";
    const orderTypeParam = orderType ? `&order_type=${orderType}` : "";
    const orderParam = order ? `&order=${order}` : "";

    return apiFashionInstance({
      method: "GET",
      url: `/profession?limit=${resultsPerPage}&page=${actualPage}${filterParam}${queryParam}${orderTypeParam}${orderParam}`,
      headers: { Authorization: userToken },
    });
  },

  getProfessionById(userToken, id) {
    return apiFashionInstance({
      method: "GET",
      url: `/profession/detail/${id}`,
      headers: { Authorization: userToken },
    });
  },

  createProfession(userToken, data) {
    return apiFashionInstance({
      method: "POST",
      url: "/profession/create",
      headers: { Authorization: userToken },
      data,
    });
  },

  setProfession(userToken, id, data) {
    return apiFashionInstance({
      method: "PUT",
      url: `/profession/update/${id}`,
      headers: { Authorization: userToken },
      data,
    });
  },

  deleteProfession(userToken, ids) {
    return apiFashionInstance({
      method: "DELETE",
      url: "/profession/",
      headers: { Authorization: userToken },
      data: { idList: ids },
    });
  },

  // app versions
  getVersions(token, productId) {
    const product = productId ? `?product_id=${productId}` : "";
    return apiFashionInstance({
      method: "GET",
      url: `/version${product}`,
      headers: { Authorization: token },
    });
  },

  getVersionById(token, id) {
    return apiFashionInstance({
      method: "GET",
      url: `/version/detail/${id}`,
      headers: { Authorization: token },
    });
  },

  // createVersion (token, data) {
  //   return apiFashionInstance({
  //     method: 'POST',
  //     url: '/version/create',
  //     headers: { Authorization: token },
  //     data
  //   })
  // },
  // deleteVersion (token, id, data) {
  //   return apiFashionInstance({
  //     method: 'DELETE',
  //     url: `/version/delete/${id}`,
  //     headers: { Authorization: token },
  //     data
  //   })
  // }

  setVersion(token, id, data) {
    return apiFashionInstance({
      method: "PUT",
      url: `/version/detail/${id}`,
      headers: { Authorization: token },
      data,
    });
  },
  getVouchers(userToken, { resultsPerPage, actualPage, order, status, query }) {
    return apiFashionInstance({
      method: "GET",
      url: `/voucher?product=14&limit=${resultsPerPage}&page=${actualPage}${order}${status}${query}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  getVoucherById(userToken, id) {
    return apiFashionInstance({
      method: "GET",
      url: `/voucher/${id}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  createVoucher(userToken, data) {
    return apiFashionInstance({
      method: "POST",
      url: "/voucher?product=14",
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },
  setVoucher(userToken, id, data) {
    return apiFashionInstance({
      method: "PUT",
      url: `/voucher/${id}?product=14`,
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },
  deleteVoucher(userToken, ids) {
    return apiFashionInstance({
      method: "DELETE",
      url: "/voucher",
      headers: {
        Authorization: userToken,
      },
      data: { idList: ids },
    });
  },
};

export default {
  install(Vue) {
    Vue.$apiFashionService = apiFashionService;
    Vue.prototype.$apiFashionService = apiFashionService;
  },
};



// WEBPACK FOOTER //
// ./src/services/fashion.js